import AddMultipleAssigneeDropdown from 'components/CustomDropdown/AddMultipleAssigneeDropdown';
import TimeRangeComponentNew from 'custom_modules/Timesheet/Daily/TimeRangeComponentNew';
import TimeDuration from 'custom_modules/Timesheet/Daily/timeDuration';
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  RedStar,
} from 'styledComponents/common';

import Select from '../../components/ReactSelectDropdown';
import AddLocationModal from './CreateTask/AddLocationModal';
import { TimeRangeSection } from './CreateTask/createTaskStyles';
import DefaultTaskLocationWarningModal from './DefaultTaskLocationWarningModal';

const CreateEditTaskForm = ({
  selectedOffice,
  officeOptions,
  officesShortList,
  filterOption,
  selectedTask,
  saveErrors,
  setSaveErrors,
  memberShortListIsLoading,
  selectedAssignees,
  orgMembersList,
  handleAssignMember,
  handleRemoveMember,
  startTime,
  setStartTime,
  startDate,
  setStartDate,
  endTime,
  setEndTime,
  endDate,
  setEndDate,
  selectedLocation,
  taskLocationOptions,
  taskDescription,
  onOfficeChange,
  CreateProjectDropdown,
  onTaskNameChange,
  popupToggle,
  onTaskDescriptionChange,
  onLocationChange,
  publicZoneOptions,
  publicZoneList,
  selectedPublicZone,
  onPublicZoneChange,
  isSameLocationWarningModalOpen,
  popupToggleSameLocationWarningModal,
  handleSave,
  isLoading,
  creating,
  popupOpen,
  addTaskLocation,
  addTaskLocationLoading,
  createdTaskLocationInfo,
  getTaskLocation,
  getOfficesShortList,
  masterTaskOptions = [],
  checklistData,
  setChecklistData,
}) => {
  const [taskInput, setTaskInput] = useState('');

  useEffect(() => {
    if (creating) {
      if (selectedTask?.sub_tasks?.length > 0) {
        const newSubTasks = selectedTask.sub_tasks.map(subTask => ({
          id: subTask.id,
          name: subTask.name,
          task_type: subTask.task_type,
          sub_task_type: subTask.sub_task_type,
          code: subTask.code,
        }));
        setChecklistData(newSubTasks);
      } else {
        setChecklistData([]);
      }
    }
  }, [selectedTask, setChecklistData]);

  const onStartDateChange = date => {
    let errors = { ...saveErrors };
    delete errors['timeDifferenceStartTime'];
    setSaveErrors(errors);
    setStartDate(date);

    if (selectedTask?.default_task_duration) {
      const newEndDate = moment(
        date.format('YYYY-MM-DD') + ' ' + startTime,
        'YYYY-MM-DD HH:mm:ss',
      ).add(selectedTask.default_task_duration, 'hours');
      setEndDate(moment(newEndDate.format('YYYY-MM-DD')));
    }
  };

  useEffect(() => {
    let startDateTime = moment(
      startDate.format('YYYY-MM-DD') + ' ' + startTime,
      'YYYY-MM-DD HH:mm:ss',
    );
    const now = moment();
    if (
      selectedTask &&
      selectedTask?.value !== selectedTask?.label &&
      (creating || startDateTime.isBefore(now))
    ) {
      if (selectedTask && (creating || startDateTime.isBefore(now))) {
        if (startDateTime.isBefore(now)) {
          startDateTime = moment().add(5, 'minutes');
          setStartDate(startDateTime);
          setStartTime(startDateTime.format('HH:mm:ss'));
        }
        const default_task_duration = selectedTask?.default_task_duration || 1;
        const newEndData = startDateTime.add(default_task_duration, 'hours');
        setEndDate(newEndData);
        setEndTime(newEndData.format('HH:mm:ss'));
      }
    }
  }, [selectedTask]);

  const handleStartTime = time => {
    if (
      moment(time.replace(/ /g, ''), 'h:mmA').format('HH:mm:ss') ===
      moment(startTime, 'h:mmA').format('HH:mm:ss')
    ) {
      return;
    }
    if (time) {
      if (handleStartTime.debounceTimeout) {
        clearTimeout(handleStartTime.debounceTimeout);
      }

      handleStartTime.debounceTimeout = setTimeout(() => {
        let errors = { ...saveErrors };
        delete errors['timeDifferenceStartTime'];
        setSaveErrors(errors);
        const start_time = time.replace(/ /g, '');
        setStartTime(moment(start_time, 'h:mmA').format('HH:mm:ss'));

        if (selectedTask?.default_task_duration) {
          const startDateTime = moment(
            startDate.format('YYYY-MM-DD') +
              ' ' +
              moment(start_time, 'h:mmA').format('HH:mm:ss'),
          );
          const newEndDate = startDateTime.add(
            selectedTask.default_task_duration,
            'hours',
          );
          setEndDate(newEndDate);
          setEndTime(newEndDate.format('HH:mm:ss'));
        }
      }, 300); // 300ms debounce delay
    } else {
      setStartTime('');
    }
  };

  const handleEndTime = time => {
    if (
      moment(time.replace(/ /g, ''), 'h:mmA').format('HH:mm:ss') ===
      moment(endTime, 'h:mmA').format('HH:mm:ss')
    ) {
      return;
    }
    if (time) {
      if (handleEndTime.debounceTimeout) {
        clearTimeout(handleEndTime.debounceTimeout);
      }

      handleEndTime.debounceTimeout = setTimeout(() => {
        let errors = { ...saveErrors };
        delete errors['timeDifferenceEndTime'];
        setSaveErrors(errors);
        const end_time = time.replace(/ /g, '');
        setEndTime(moment(end_time, 'h:mmA').format('HH:mm:ss'));
      }, 300); // 300ms debounce delay
    } else {
      setEndTime('');
    }
  };
  const onEndDateChange = date => {
    let errors = { ...saveErrors };
    delete errors['timeDifferenceEndTime'];
    setSaveErrors(errors);
    setEndDate(date);
  };

  return (
    <>
      <AddLocationModal
        isOpen={popupOpen}
        toggle={popupToggle}
        addTaskLocation={addTaskLocation}
        addTaskLocationLoading={addTaskLocationLoading}
        createdTaskLocationInfo={createdTaskLocationInfo}
        getTaskLocation={getTaskLocation}
        getOfficesShortList={getOfficesShortList}
        officesShortList={officesShortList}
        publicZoneList={publicZoneList}
        onLocationChange={onLocationChange}
      />
      <DefaultTaskLocationWarningModal
        isOpen={isSameLocationWarningModalOpen}
        toggle={popupToggleSameLocationWarningModal}
        handleCreate={handleSave}
        isLoading={isLoading}
        creating={creating}
      />
      <CommonGrid
        style={{ gridColumn: `1 / span 2` }}
        columns="1fr 1fr"
        justifyContent="none"
        gap="40px"
      >
        <InputWithLabelSection>
          <InputLabel>
            {t('public_zone')} <RedStar>*</RedStar>
          </InputLabel>
          <Select
            isSearchable
            value={selectedPublicZone}
            options={publicZoneOptions}
            placeholder={t('select_zone')}
            isDisabled={
              !creating || (publicZoneList && publicZoneList.length === 1)
            }
            onChange={e => {
              onPublicZoneChange(e);
            }}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
          />
        </InputWithLabelSection>
        <InputWithLabelSection>
          <InputLabel>
            {t('office')} <RedStar>*</RedStar>
          </InputLabel>
          <Select
            isSearchable
            value={selectedOffice}
            options={officeOptions}
            placeholder={t('select_office')}
            isDisabled={
              !creating || (officesShortList && officesShortList.length === 1)
            }
            onChange={e => {
              onOfficeChange(e);
            }}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
          />
        </InputWithLabelSection>
      </CommonGrid>
      <CommonGrid
        style={{ gridColumn: `1 / span 2` }}
        columns="1fr"
        justifyContent="none"
        gap="40px"
      >
        <InputWithLabelSection>
          <InputLabel>
            {t('task_name')} <RedStar>*</RedStar>
          </InputLabel>
          <Select
            isSearchable
            value={selectedTask}
            options={[
              ...masterTaskOptions,
              ...(taskInput &&
              !masterTaskOptions?.some(option => option?.label === taskInput)
                ? [{ label: `${taskInput} (${t('add_this')})`, value: null }]
                : []),
            ]}
            placeholder={t('type_task_name')}
            isDisabled={!creating}
            onChange={e => {
              if (
                taskInput?.length > 0 &&
                !masterTaskOptions.some(option => option.label === e.label)
              ) {
                const newOption = { label: taskInput, value: taskInput };
                masterTaskOptions.push(newOption);
                onTaskNameChange(newOption);
              } else {
                onTaskNameChange(e);
              }
            }}
            onInputChange={inputValue => {
              setTaskInput(inputValue);
            }}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
            isClearable
          />
          {saveErrors && saveErrors['taskName'] && (
            <FormAlert>{saveErrors['taskName']}</FormAlert>
          )}
        </InputWithLabelSection>
        {/* <CommonFlex justifyContent="center">
          <InputWithLabelSection>
            <InputLabel>
              {t('assignee')}
              <RedStar>*</RedStar>
            </InputLabel>

            <AddMultipleAssigneeDropdown
              numberOfVisibleMembers={8}
              isLoading={memberShortListIsLoading}
              assigneesList={selectedAssignees}
              membersList={orgMembersList}
              handleAssign={handleAssignMember}
              handleRemove={handleRemoveMember}
            />

            {saveErrors && saveErrors['selectedAssignees'] && (
              <FormAlert>{saveErrors['selectedAssignees']}</FormAlert>
            )}
          </InputWithLabelSection>
        </CommonFlex> */}
      </CommonGrid>
      {/* <InputWithLabelSection>
        <TimeRangeSection>
          <InputLabel>
            {t('start_date')}
            <RedStar>*</RedStar>
          </InputLabel>
          <InputLabel>
            {t('start_time')}
            <RedStar>*</RedStar>
          </InputLabel>
        </TimeRangeSection>
        <TimeRangeComponentNew
          initialTime={startTime}
          selectedDate={startDate}
          onDateChange={onStartDateChange}
          setTime={handleStartTime}
        />
        {saveErrors &&
          saveErrors['timeDifferenceStartTime'] &&
          saveErrors['timeDifferenceStartTime'] !== undefined && (
            <FormAlert>{saveErrors['timeDifferenceStartTime']}</FormAlert>
          )}
      </InputWithLabelSection>
      <CommonFlex direction="column" alignItems="start" gap="5px">
        <InputWithLabelSection width="100%">
          <TimeRangeSection>
            <InputLabel>
              {t('end_date')}
              <RedStar>*</RedStar>
            </InputLabel>
            <InputLabel>
              {t('end_time')}
              <RedStar>*</RedStar>
            </InputLabel>
          </TimeRangeSection>
          <TimeRangeComponentNew
            initialTime={endTime}
            selectedDate={endDate}
            onDateChange={onEndDateChange}
            setTime={handleEndTime}
            mode="end"
          />
          {saveErrors &&
            saveErrors['timeDifferenceEndTime'] &&
            saveErrors['timeDifferenceEndTime'] !== undefined && (
              <FormAlert>{saveErrors['timeDifferenceEndTime']}</FormAlert>
            )}
        </InputWithLabelSection>
      </CommonFlex>{' '} */}
      {/* <CommonGrid
        style={{ gridColumn: `1 / span 2` }}
        columns="1fr"
        justifyContent="none"
        gap="40px"
      >
        <TimeDuration
          startDate={startDate}
          endDate={endDate}
          startTime={startTime}
          endTime={endTime}
        />
      </CommonGrid> */}
      <InputWithLabelSection>
        <CommonGrid>
          <InputLabel>
            {t('location')} <RedStar>*</RedStar>
          </InputLabel>
          {/* <ColoredText
            fontSize="12px"
            type="success"
            hover
            semibold
            style={{ cursor: `pointer` }}
            onClick={() => popupToggle()}
          >
            {t('add_new_location')}
          </ColoredText> */}
        </CommonGrid>
        <Select
          isSearchable
          value={selectedLocation}
          options={taskLocationOptions}
          placeholder={t('select_location')}
          onChange={e => {
            onLocationChange(e);
          }}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
        {saveErrors &&
          saveErrors['selectedLocation'] &&
          saveErrors['selectedLocation'] !== undefined && (
            <FormAlert>{saveErrors['selectedLocation']}</FormAlert>
          )}
      </InputWithLabelSection>
      <InputWithLabelSection style={{ gridColumn: `1 / span 2` }}>
        <InputLabel>
          {t('description')}
          <RedStar>*</RedStar>
        </InputLabel>
        <InputTextArea
          text="Description"
          cols="35"
          rows="7"
          value={taskDescription}
          placeholder={t('type_description_here')}
          onChange={e => onTaskDescriptionChange(e)}
          height="auto"
          style={
            saveErrors &&
            saveErrors[`taskDescription`] && {
              border: `1px solid #fe5969`,
              backgroundColor: `rgba(252, 87, 104, 0.05)`,
            }
          }
        ></InputTextArea>
        {saveErrors &&
          saveErrors['taskDescription'] &&
          saveErrors['taskDescription'] !== undefined && (
            <FormAlert>{saveErrors['taskDescription']}</FormAlert>
          )}
      </InputWithLabelSection>
    </>
  );
};

export default CreateEditTaskForm;
